import { Placement } from "@popperjs/core";
import React, { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import styled, { css } from "styled-components";
import { Div } from "../utils";

type TooltipContentProps = {
  isActionable?: boolean;
};
export const TooltipContent = styled(Div)<TooltipContentProps>`
  ${(p) =>
    p.isActionable
      ? css`
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
          background: ${(p) => p.theme.colors.white};
          border-radius: 18px;
          padding: 10px 12px;
        `
      : css`
          padding: 4px 6px;
          background: rgba(0, 0, 0, 0.6);
          color: ${(p) => p.theme.colors.white};
          border-radius: 3px;
          font-size: 11px;
          font-weight: 400;
          ${(p) => p.theme.css.alignCenter};
        `}
`;

const TooltipContainer = styled(Div)`
  user-select: none;
`;

type TooltipProps = {
  parent: React.ReactNode;
  isActionable?: boolean;
  children?: React.ReactNode;
  placement?: Placement;
};
export const Tooltip: React.FC<TooltipProps> = ({
  parent,
  isActionable,
  children,
  placement,
  ...props
}) => {
  const [isDisplayingTooltip, setIsDisplayingTooltip] = useState(false);
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null
  );
  const { styles, attributes, update } = usePopper(
    referenceElement,
    popperElement,
    {
      placement: placement || "top-start",
      
    }
  );

  useEffect(() => {
    if (update) update();
  }, [isDisplayingTooltip]);

  return (
    <>
      <TooltipContainer
        ref={setReferenceElement}
        onMouseOver={() => setIsDisplayingTooltip(true)}
        onMouseOut={() => setIsDisplayingTooltip(false)}
        {...props}
      >
        {parent}
      </TooltipContainer>
      {isDisplayingTooltip && (
        <TooltipContent
          isActionable={isActionable}
          ref={setPopperElement}
          style={styles.popper}
          {...attributes.popper}
        >
          {children}
        </TooltipContent>
      )}
    </>
  );
};
